import {
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import {
  AlertController,
  ModalController,
  Platform,LoadingController,MenuController
} from '@ionic/angular';
import { MenuService } from '../../services/menu.service';
import { ForgetComponent } from '../forget/forget.component';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss'],
})
export class LogInComponent implements OnInit {
  show_pass = true;
  submitted = false;
  mobile_no;
  otp;
  pwd_policy_msg;
  focus: any = {}; //Focus styling
  loginform:any= FormGroup;
  otp_form:any= FormGroup;
  shake;
  otp_submit;
  alert_message;
  constructor(public loadingController: LoadingController,private menuCtrl: MenuController,public menu: MenuService,public db: DataService, private modalCtrl: ModalController, private alertCtrl: AlertController, private platform: Platform, private router: Router, private formbuilder: FormBuilder) { }

 ngOnInit() {
    this.loginform = this.formbuilder.group({
      // username: new FormControl('', [Validators.required, Validators.email]),
      username : new FormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      password: new FormControl('', [Validators.required])
    })
      this.menuCtrl.enable(false, 'profileMenu');

  }

  get username() {
    return this.loginform.get('username');
  }

  get password() {
    return this.loginform.get('password');
  }

  async login() {
 
    this.submitted = true;
    if (this.loginform.status == 'VALID') {

      const loading = await this.loadingController.create({
        message: 'Please wait...',
        duration: 2000
      });
      await loading.present();

      let data = {
        usr: this.loginform.value.username,
        pwd: this.loginform.value.password,
        // role:'vendor'
      }
      this.db.customer_login(data).subscribe(res => {
        // loading.onDidDismiss();
        if (res['message'].status == "success") {
          localStorage['domain_api_key'] = res['message'].api_key;
          localStorage['domain_api_secret'] = res['message'].api_secret;
          localStorage['domain_customerId'] = this.loginform.value.username; 
          localStorage['CustomerPwd'] = this.loginform.value.password;
          this.menu.enable_pos_menu = true;
          this.menuCtrl.enable(true, 'profileMenu');
          this.menu.set_pos_menu();
          // this.router.navigateByUrl("/admin-dashboard")
          // this.menu.get_pos_all_products();
          // localStorage.business = 'BS-00001';
          this.db.admin_Info(this.loginform.value.username)
            .subscribe(data => {
             localStorage['adminRefId'] = data.message[0].name
             localStorage['business'] = data.message[0].restaurant
             localStorage['restaurant_name'] = data.message[0].restaurant_name;
             this.db.restaurant_name = data.message[0].restaurant_name;
             this.db.login_info.restaurant_name = this.db.restaurant_name;
            // this.menu.set_pos_menu();
             localStorage['print_type'] = 'Normal';
             this.db.cust_name = localStorage['restaurant_name'];
            this.menu.get_business_settings();
            this.menu.get_pos_all_products();
            this.db.get_profiles();
            this.router.navigateByUrl("/admin-dashboard");
            loading.onDidDismiss();
              },
            error => {
          loading.onDidDismiss();
          console.log(JSON.stringify(error.json()));
          })
          
        }else if (res['message'].status == "failed") {
          loading.onDidDismiss();
          this.db.alert(res['message'].message)
        }
      },error => {
          loading.onDidDismiss();
          this.alert_message = 'Check Email/Password';
          // console.log(JSON.stringify(error.json()));
        }
      )
    }
  }

  @HostListener('window:resize', ['$event'])
  private func() {
    this.db.ismobile = this.db.checkmobile();
  }

  
  clear_otp(){
    localStorage['otp_mobile'] = undefined;
    this.db.is_select  = true;
    this.router.navigateByUrl('/web-page?page_route=seller-on-boarding');
  }

  goto_terms(){
   this.router.navigateByUrl('/terms?id=seller-terms-conditions'); 
  }

  goto_policy(){
   this.router.navigateByUrl('/terms?id=seller-privacy-policy'); 
  }
  
  async forgot(){
    let modal = await this.modalCtrl.create({
      component: ForgetComponent,
      cssClass: !this.db.ismobile ? 'forget-popup' : 'address-popup',
      componentProps: { modal : true }
    });
    await modal.present();
    let { data } = await modal.onWillDismiss();
    if(data) {

    }
  }
  
}
